import { Component, Inject, Vue } from 'vue-property-decorator';
import { Mission } from '@/domain/project/Mission';
import { MissionFilterDataSet, toMissionFilterDataSet, toMissions } from '@/primary/template-sidebar/mission-filter/MissionFilterDataSet';
import { Store } from '@/primary/store/Store';

@Component
export default class MissionFilterComponent extends Vue {
  @Inject()
  store!: () => Store;

  missionFilterDataSet: MissionFilterDataSet = toMissionFilterDataSet([
    Mission.DIFFUSION,
    Mission.ENSEIGNEMENT,
    Mission.COLLECTIONS,
    Mission.EXPERTISE,
    Mission.RECHERCHE,
  ]);

  toggleDiffusion() {
    this.missionFilterDataSet.diffusion.active = !this.missionFilterDataSet.diffusion.active;
    this.store().saveMissionFilter(toMissions(this.missionFilterDataSet));
  }

  toggleEnseignement() {
    this.missionFilterDataSet.enseignement.active = !this.missionFilterDataSet.enseignement.active;
    this.store().saveMissionFilter(toMissions(this.missionFilterDataSet));
  }

  toggleCollections() {
    this.missionFilterDataSet.collections.active = !this.missionFilterDataSet.collections.active;
    this.store().saveMissionFilter(toMissions(this.missionFilterDataSet));
  }

  toggleExpertise() {
    this.missionFilterDataSet.expertise.active = !this.missionFilterDataSet.expertise.active;
    this.store().saveMissionFilter(toMissions(this.missionFilterDataSet));
  }

  toggleRecherche() {
    this.missionFilterDataSet.recherche.active = !this.missionFilterDataSet.recherche.active;
    this.store().saveMissionFilter(toMissions(this.missionFilterDataSet));
  }
}
